export default __webpack_public_path__ + "static/media/KeyboardDoubleArrowRightRounded.6a750a69.svg";